export const EmptyNotification = () => {
  return (
    <div className="flex items-center justify-center px-6 py-4 text-gray-700">
      沒有通知
    </div>
  );
};
